import React, { FC } from 'react';
import DashBoardFrame from './DashBoardFrame';
import { FeatureFlag, useFeatureFlag } from 'src/helpers/featureFlag';
import { useBackHref } from 'src/helpers/history';
import { Navigate } from 'react-router-dom';

const RamaPage: FC = () => {
  const backHref = useBackHref();
  const isRamaFeature = useFeatureFlag(FeatureFlag.Rama_Visualizations);

  return isRamaFeature ? <DashBoardFrame /> : <Navigate to={backHref} />;
};

export default RamaPage;
